import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import QuoteSwiper from 'components/QuoteSwiper/QuoteSwiper'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  return (
    <AppContainer $colorMode={colorMode}>
      <QuoteSwiper quoteContent={properties?.textContent} withoutQuotes={properties?.withoutQuotes} bold={properties?.bold} fontFamily={properties?.fontFamily}/>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
